// extracted by mini-css-extract-plugin
export default {"root":"ReviewRatingCustom_root__fIDTz"};